module.exports = __webpack_public_path__ + "img/requisits.30aac862.svg";